import { LOCATIONS } from 'constants/index';

const { uniqueId } = require('lodash');

export const STEP = {
  INFO: 'INFO',
  PERMISSION: 'PERMISSION',
};

export const PERMISSION = [
  {
    _id: uniqueId(),
    label: 'Quản lý chỗ nghỉ',
    desc: 'Quản lý số lượng bán tại chỗ nghỉ và tình trạng phòng trống, giá cả cùng chính sách dành cho khách.',
    path: LOCATIONS.LOCATION_ADD,
    value: 'managePlace',
  },
  {
    _id: uniqueId(),
    label: 'Dữ liệu và Hiệu suất',
    desc: 'Truy cập vào dữ liệu hiệu suất kinh doanh và thông tin chuyên sâu.',
    path: LOCATIONS.LOCATION_DETAIL.ANALYSIS_OVERVIEW,
    value: 'performanceData',
  },
  {
    _id: uniqueId(),
    label: 'Tài chính',
    desc: 'Xem và quản lý các tài liệu cùng cài đặt tài chính.',
    path: LOCATIONS.LOCATION_DETAIL.FINANCE,
    value: 'finance',
  },
  {
    _id: uniqueId(),
    label: 'Đơn đặt',
    desc: 'Tất cả các mảng liên quan đến đơn đặt, bao gồm yêu cầu chỉnh sửa, phí và chức năng nhắn tin cho khách.',
    path: [LOCATIONS.MANAGER_BOOKING, LOCATIONS.LOCATION_DETAIL.MANAGER_BOOKING],
    value: 'bookings',
    children: [
      {
        _id: uniqueId(),
        label: 'Xem danh sách đặt phòng',
        value: 'viewBookings',
      },
      {
        _id: uniqueId(),
        label: 'Xem chi tiết các booking tại chỗ nghỉ',
        path: LOCATIONS.MANAGER_BOOKING_DETAIL,
        value: 'viewDetails',
      },
      {
        _id: uniqueId(),
        label: 'Hủy đặt phòng',
        value: 'cancelBooking',
      },
    ],
  },
  {
    _id: uniqueId(),
    label: 'Khuyến mãi',
    desc: 'Thiết lập ưu đãi, giảm giá cùng các ưu đãi đặc biệt khác.',
    value: 'promotions',
    path: LOCATIONS.LOCATION_DETAIL.PROMOTION,
    children: [
      {
        _id: uniqueId(),
        label: 'Xem được danh sách khuyến mãi theo từng trạng thái',
        value: 'viewPromotions',
      },
      {
        _id: uniqueId(),
        label: 'Thiết lập các ưu đãi, giảm giá cho chỗ nghỉ',
        path: [LOCATIONS.LOCATION_DETAIL.CREATE_PROMOTION,
          LOCATIONS.LOCATION_DETAIL.CREATE_BASIC_PROMOTION,
          LOCATIONS.LOCATION_DETAIL.CREATE_LONG_TERM_PROMOTION,
          LOCATIONS.LOCATION_DETAIL.CREATE_LAST_MINUTE_PROMOTION,
          LOCATIONS.LOCATION_DETAIL.CREATE_EARLY_PROMOTION],
        value: 'managePromotions',
      },
    ],
  },
  {
    _id: uniqueId(),
    label: 'Quản lý khách hàng',
    desc: 'Xem chi tiết, thêm hoặc chặn người dùng',
    path: LOCATIONS.CUSTOMERS,
    value: 'customerManagement',
    children: [
      {
        _id: uniqueId(),
        label: 'Hiển thị danh sách người dùng tại hệ thống',
        value: 'viewCustomers',
      },
      {
        _id: uniqueId(),
        label: 'Thêm người dùng tại hệ thống',
        value: 'addCustomers',
      },
      {
        _id: uniqueId(),
        label: 'Sửa người dùng tại hệ thống',
        path: LOCATIONS.CUSTOMERS,
        value: 'editCustomers',
      },
      {
        _id: uniqueId(),
        label: 'Xoá người dùng tại hệ thống',
        value: 'deleteCustomers',
      },
    ],
  },
  {
    _id: uniqueId(),
    label: 'Quản lý tài khoản phân quyền',
    desc: 'Thêm hoặc xóa tài khoản phân quyền và thay đổi quyền truy cập vào extranet của họ.',
    value: 'accountPermissions',
    path: LOCATIONS.MANAGER_USER_ACCOUNT,
    children: [
      {
        _id: uniqueId(),
        label: 'Xem danh sách các tài khoản phân quyền',
        value: 'viewAccounts',
      },
      {
        _id: uniqueId(),
        label: 'Thêm tài khoản khoản phân quyền',
        value: 'addAccount',
      },
      {
        _id: uniqueId(),
        label: 'Sửa tài khoản phân quyền',
        value: 'editAccount',
      },
      {
        _id: uniqueId(),
        label: 'Xóa tài khoản phân quyền',
        value: 'deleteAccount',
      },
    ],
  },
];

export const initialPermissionsState = {
  accountSetting: {
    managePlace: false,
    performanceData: false,
    finance: false,
    bookings: {
      viewBookings: false,
      viewDetails: false,
      cancelBooking: false,
    },
    promotions: {
      viewPromotions: false,
      managePromotions: false,
    },
    customerManagement: {
      viewCustomers: false,
      addCustomers: false,
      editCustomers: false,
      deleteCustomers: false,
    },
    accountPermissions: {
      viewAccounts: false,
      addAccount: false,
      editAccount: false,
      deleteAccount: false,
    },
  },
  placesToApply: [],
};
